import { RootState } from 'modules'
import { ISubject } from 'utils/data'

export const selectSubject = (state: RootState): ISubject | null =>
  state.subject
